import O1HD from "../../../engines/gameEngine";
import normalMode from "../normalMode";
import { WeChatEvent, WeChatManagerPeople } from "./WeChatConst";

export interface WeChatManagerData{
    peoples:WeChatManagerPeople[],

}

export default class WeChatManager{

    constructor(gameLayer:normalMode){
        this.gameLayer = gameLayer;
        this.loadGameData();
    }

    gameLayer:normalMode = null;

    private _gameDataSaveKey:string = "game-data-save-key";

    private _initPeoples:WeChatManagerPeople[] = [
        // {peopleId:"自己",peopleChatLinkQueue:["0"],peopleChatLastLink:null},
        // {peopleId:"妈妈",peopleChatLinkQueue:["0"],peopleChatLastLink:null}
    ];

    private _gameData:WeChatManagerData = {
        peoples:this._initPeoples,
    }

    loadGameData(){
        let dataStr = O1HD.getServices().localStorageSrv.getStorage(this._gameDataSaveKey) || JSON.stringify(this._gameData);
        if(dataStr == ""){
            dataStr = JSON.stringify(this._gameData);
        }
        this._gameData = JSON.parse(dataStr);
        this.writeGameData();
    }

    getGameData(){
        return this._gameData;
    }

    resetGameData(){
        this._gameData.peoples = this._initPeoples.concat();
        this.writeGameData();
    }

    writeGameData(){
        O1HD.getServices().localStorageSrv.setStorage(this._gameDataSaveKey,JSON.stringify(this.getGameData()));
    }

    addOnePeople(peopleId:string,weChatLinkId:string,unshiftFlag : boolean = false){
        let people = this.getOnePeopleById(peopleId);
        let peoples = this.getGameData().peoples;
        if(people){
            // 如果有则把聊天加到对应的聊天队列中
            let ary = people.peopleChatLinkQueue;
            if ( unshiftFlag == false ) {
                ary.push(weChatLinkId);
            }else{
                ary.unshift(weChatLinkId);
            }
            // people.bNewChat = true;
            // people.peopleChatLastLink = null;
            let p = this.splitOnePeople(peopleId);
            peoples.unshift(p);
        }else{
            // 如果没有则把人加到对应的人的队列中 再把对应的聊天加到对应的人中
            let onePeople:WeChatManagerPeople = {
                peopleId: peopleId,
                peopleChatLinkQueue: [weChatLinkId],
                peopleChatLastLink: null,
                bNewChat: true,
            }
            peoples.unshift(onePeople);
            people = onePeople;
            O1HD.getManagers().soundMgr.playSound("weChatNewMessage");
        }
        O1HD.emit(WeChatEvent.UPDATEWECHATMAIN);
        O1HD.emit('normalMode.notifyNewChatMessage', peopleId);
        this.writeGameData();
        return people;
    }

    splitOnePeople(peopleId:string){
        let index = this.getPeopleIndexById(peopleId);
        let ary : WeChatManagerPeople[] = [];
        if(index > -1){
            ary = this.getGameData().peoples.splice(index,1);
        }
        this.writeGameData();
        return ary[0];
    }

    getOnePeopleById(peopleId:string){
        let peoples = this.getGameData().peoples;
        return peoples.find(id=>{
            return id.peopleId == peopleId;
        });
    }

    getPeopleIndexById(peopleId:string){
        let peoples = this.getGameData().peoples;
        return peoples.findIndex(id=>{
            return id.peopleId == peopleId;
        });
    }

    getPeoples(){
        return this.getGameData().peoples;
    }
}
